// extracted by mini-css-extract-plugin
module.exports =  {"radio":"_0d624b9a27--radio--xGbrA","indicator":"_0d624b9a27--indicator--UVUda","label":"_0d624b9a27--label--ZoQ_y"};